import {
  assign
} from 'min-dash';

export default function contextPadProvider(connect, contextPad, modeling,elementFactory,autoPlace,create,myOptions) {
  this._connect = connect;
  this._modeling = modeling;
  this._elementFactory = elementFactory;
  this._autoPlace = autoPlace;
  this._create = create;
  this._myOptions = myOptions;

  contextPad.registerProvider(this);
}
  
contextPadProvider.$inject = [
  'connect',
  'contextPad',
  'modeling',
  'elementFactory',
  'autoPlace',
  'create',

  'myOptions'
];
  
contextPadProvider.prototype.getContextPadEntries = function(element) {
  var connect = this._connect,
      modeling = this._modeling,
      elementFactory = this._elementFactory,
      autoPlace = this._autoPlace,
      create = this._create,
      myOptions = this._myOptions;

  function removeElement() {
    modeling.removeElements([ element ]);
  }

  function startConnect(event, element, autoActivate) {
    connect.start(event, element, autoActivate);
  }

  function appendAction(type, className, title, options) {

    if (typeof title !== 'string') {
      options = title;
      //title = title;
    }

    function appendStart(event, element) {
      var shape = elementFactory.createShape(assign({ type: type }, options));
      create.start(event, shape, {
        source: element
      });
    }

    function append(event, element) {
      var shape = elementFactory.createShape(assign({ type: type }, options));
      autoPlace.append(element, shape);
    }

    return {
      group: 'model',
      className: className,
      title: title,
      action: {
        dragstart: appendStart,
        click: append
      }
    };
  }

  if(element.type == 'label'){
    return false;
  }

  

  if(element.type == 'myline' || element.type == 'endEvent'){
    return {
      'delete': {
        group: 'edit',
        className: 'icon-delete',
        title: '删除',
        action: {
          click: removeElement,
          dragstart: removeElement
        }
      },
    };
  }

  var tools =  {
  };

  for(let key in myOptions.palette){
    if(key != 'create.start-event'){
      var item = myOptions.palette[key];
      tools[key] = appendAction(item.type,item.className, item.title,item.options);
    }
   
  }


  tools['connect'] = {
    group: 'edit',
    className: 'icon-line-tool',
    title: '连线',
    action: {
      click: startConnect,
      dragstart: startConnect
    }
  }

  tools['delete'] = {
    group: 'edit',
    className: 'icon-delete',
    title: '删除',
    action: {
      click: removeElement,
      dragstart: removeElement
    }
  }

  return tools;

};
